// api/report.js
import request from './request'

export const reportApi = {
    // TikTok 通用同步报表
    getIntegratedReport(data) {
        return request({
            url: '/api/report/integrated',
            method: 'post',
            withCredentials: false,
            data
        })
    },

    // 创意概览报告
    getMaterialOverview(params) {
        return request({
            url: '/report/material/overview',
            method: 'get',
            params
        })
    },

    // 创意细分报告
    getMaterialBreakdown(params) {
        return request({
            url: '/report/material/breakdown',
            method: 'get',
            params
        })
    }
}
